import React from "react";

function AlertMessage() {
  return <div className="alert success">Email sent successfully!</div>;
}

export default AlertMessage;
